/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Totalofferslabel2Inputs */

const id_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total penawaran`)
};

const ms_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah tawaran`)
};

const da_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlede tilbud`)
};

const de_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebote insgesamt`)
};

const en_us2_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total offers`)
};

const es_es2_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de ofertas de catálogo`)
};

const es_mx2_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de ofertas`)
};

const fil_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabuuang offer`)
};

const fr_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total des offres`)
};

const it_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale offerte`)
};

const hu_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összes ajánlat`)
};

const nl_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal aanbiedingen`)
};

const no_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt tilbud`)
};

const pl_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łączna liczba ofert`)
};

const pt_br2_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de ofertas de catálogo`)
};

const pt_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de ofertas`)
};

const ro_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total oferte`)
};

const fi_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjouksia yhteensä`)
};

const sv_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt antal erbjudanden`)
};

const vi_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng số ưu đãi`)
};

const tr_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toplam teklif`)
};

const cs_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celkem nabídek`)
};

const bg_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общо оферти`)
};

const ru_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего предложений`)
};

const uk_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усього пропозицій`)
};

const ar_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي العروض`)
};

const hi_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल ऑफ़र`)
};

const th_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอทั้งหมด`)
};

const ja_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファー総数`)
};

const zh_cn2_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录项总数`)
};

const zh_hant1_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目錄項目總數`)
};

const ko_sandboxes_totalofferslabel2 = /** @type {(inputs: Sandboxes_Totalofferslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 오퍼`)
};

/**
* | output |
* | --- |
* | "Total offers" |
*
* @param {Sandboxes_Totalofferslabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_totalofferslabel2 = /** @type {((inputs?: Sandboxes_Totalofferslabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Totalofferslabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_totalofferslabel2(inputs)
	if (locale === "ms") return ms_sandboxes_totalofferslabel2(inputs)
	if (locale === "da") return da_sandboxes_totalofferslabel2(inputs)
	if (locale === "de") return de_sandboxes_totalofferslabel2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_totalofferslabel2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_totalofferslabel2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_totalofferslabel2(inputs)
	if (locale === "fil") return fil_sandboxes_totalofferslabel2(inputs)
	if (locale === "fr") return fr_sandboxes_totalofferslabel2(inputs)
	if (locale === "it") return it_sandboxes_totalofferslabel2(inputs)
	if (locale === "hu") return hu_sandboxes_totalofferslabel2(inputs)
	if (locale === "nl") return nl_sandboxes_totalofferslabel2(inputs)
	if (locale === "no") return no_sandboxes_totalofferslabel2(inputs)
	if (locale === "pl") return pl_sandboxes_totalofferslabel2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_totalofferslabel2(inputs)
	if (locale === "pt") return pt_sandboxes_totalofferslabel2(inputs)
	if (locale === "ro") return ro_sandboxes_totalofferslabel2(inputs)
	if (locale === "fi") return fi_sandboxes_totalofferslabel2(inputs)
	if (locale === "sv") return sv_sandboxes_totalofferslabel2(inputs)
	if (locale === "vi") return vi_sandboxes_totalofferslabel2(inputs)
	if (locale === "tr") return tr_sandboxes_totalofferslabel2(inputs)
	if (locale === "cs") return cs_sandboxes_totalofferslabel2(inputs)
	if (locale === "bg") return bg_sandboxes_totalofferslabel2(inputs)
	if (locale === "ru") return ru_sandboxes_totalofferslabel2(inputs)
	if (locale === "uk") return uk_sandboxes_totalofferslabel2(inputs)
	if (locale === "ar") return ar_sandboxes_totalofferslabel2(inputs)
	if (locale === "hi") return hi_sandboxes_totalofferslabel2(inputs)
	if (locale === "th") return th_sandboxes_totalofferslabel2(inputs)
	if (locale === "ja") return ja_sandboxes_totalofferslabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_totalofferslabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_totalofferslabel2(inputs)
	return ko_sandboxes_totalofferslabel2(inputs)
});
export { sandboxes_totalofferslabel2 as "sandboxes.totalOffersLabel" }